import styled, { css } from 'styled-components/macro';

import Button from 'components/Button/Button';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import Typography from 'components/Typography/Typography';

type FilterButtonStyledT = {
  isActive?: boolean;
  isMultiFilter?: boolean;
};

export const popupContentStyle = {
  width: '100%',
  height: '100%',
  padding: '1.75rem 0',
};

export const FilterBtnStyled = styled(Button)<FilterButtonStyledT>`
  background-color: ${({ theme, isActive }) =>
    isActive ? theme.colors.secondary.variant3 : theme.colors.white};

  &:first-of-type {
    margin-left: 0.375rem;
  }

  &:not(:last-of-type) {
    margin-right: 0.375rem;
  }

  ${({ theme }) => `
    ${theme.devices.smallDesktop} {
      &:first-of-type {
        margin-left: 0.875rem;
      }
    }
  `}
`;

const activeMobileFilterBtnStateCss = css<FilterButtonStyledT>`
  background-color: ${({ theme }) => theme.colors.primary.variant1};
  color: ${({ theme }) => theme.colors.white};
`;

const multiFilterBtnCss = css<FilterButtonStyledT>`
  &:nth-of-type(odd) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  &:nth-of-type(even) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`;

export const MobileFilterBtnStyled = styled(Button)<FilterButtonStyledT>`
  width: 50%;
  height: 42px;
  margin-top: 0.25rem;

  ${({ isActive }) => (isActive ? activeMobileFilterBtnStateCss : '')}
  ${({ isMultiFilter = false }) => (isMultiFilter ? multiFilterBtnCss : '')}
`;
export const MobileSortingBtnStyled = styled(MobileFilterBtnStyled)<FilterButtonStyledT>`
  width: 25%;
  margin-top: 0;
`;

export const MobileFooterBtnStyled = styled(Button)`
  flex: 1;
  border-radius: 0;
  height: 50px;
`;

export const MobileResultsBtnStyled = styled(MobileFooterBtnStyled)`
  border: ${({ theme }) => `${theme.borders.xs} ${theme.colors.primary.variant6}`};
`;

export const TitleStyled = styled(Typography)`
  font-size: ${({ theme }) => theme.fontSize['4xl']};
`;

export const MobileFiltersWrapStyled = styled.div`
  width: 90%;
  margin: 1.5rem auto 0;
`;

export const MobileFiltersRowWrapStyled = styled.div`
  margin-top: 1rem;
`;

export const MobileFiltersFooterStyled = styled.div`
  width: 100%;
  display: flex;
  position: absolute;
  left: 0;
  bottom: 0;
`;

export const SortingWrapStyled = styled(FlexContainer)`
  flex-direction: column;
  align-items: flex-start;

  ${({ theme }) => `
    ${theme.devices.smallDesktop} {
      flex-direction: row;
    }
  `}
`;

export const SortingTypeStyled = styled(Typography)`
  font-weight: ${({ theme }) => theme.fontWeight.bold};

  ${({ theme }) => `
    ${theme.devices.smallDesktop} {
      margin-left: 0.25rem;
    }
  `}
`;
